import React from 'react'
import { ToastContainer } from 'react-toastify'
import Paylink from './components/Paylink'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './styles/paylink.css'

type Props = {
    paylinkId: string
}

export default function App({paylinkId}: Props) {
    const queryClient = new QueryClient();

        
    return (
        <div>
            <QueryClientProvider client={queryClient}>
                <Paylink paylinkId={paylinkId} />
            </QueryClientProvider>
            <ToastContainer />
        </div>
    )
}